import { c as _c } from "react/compiler-runtime";
import { usePermissions, useUserTeams } from '@openclassrooms/data-connect-web/users';
import { useOrganizationPermissions } from '@openclassrooms/data-connect-web/organizations';
import { useTeamsPermissions } from '@openclassrooms/data-connect-web/teams';
import { ROUTES, getPathName } from '@openclassrooms/routing';
import type { User as ApiUser } from '@openclassrooms/sdk-web';
export default function useEmployerSpaceLink(user) {
  const $ = _c(32);
  const organizationId = user?.organization?.id;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = Boolean(user?.id);
  let t2;
  if ($[1] !== t1) {
    t2 = {
      retry: 0,
      enabled: t1
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    can
  } = usePermissions(t0, t2);
  let t3;
  if ($[3] !== organizationId) {
    t3 = organizationId ? {
      organizationId
    } : undefined;
    $[3] = organizationId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = Boolean(organizationId);
  let t5;
  if ($[5] !== t4) {
    t5 = {
      enabled: t4,
      retry: 0
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const {
    can: canOrganization
  } = useOrganizationPermissions(t3, t5);
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {};
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = Boolean(user?.id);
  let t8;
  if ($[8] !== t7) {
    t8 = {
      enabled: t7,
      retry: 0
    };
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const {
    can: canTeam
  } = useTeamsPermissions(t6, t8);
  let t9;
  if ($[10] !== user) {
    t9 = user?.id ? {
      userId: user.id
    } : undefined;
    $[10] = user;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = Boolean(user?.id);
  let t11;
  if ($[12] !== t10) {
    t11 = {
      enabled: t10,
      retry: 0
    };
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const {
    data: t12
  } = useUserTeams(t9, t11);
  let t13;
  if ($[14] !== can || $[15] !== canOrganization || $[16] !== canTeam || $[17] !== organizationId || $[18] !== t12 || $[19] !== user) {
    t13 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const userTeams = t12 === undefined ? {
        entities: []
      } : t12;
      const t14 = !user;
      if ($[21] !== can || $[22] !== canOrganization || $[23] !== organizationId || $[24] !== t14) {
        if (t14) {
          t13 = "";
          break bb0;
        }
        const t15 = !organizationId;
        if ($[25] !== can || $[26] !== canOrganization || $[27] !== organizationId || $[28] !== t15) {
          if (t15) {
            t13 = "";
            break bb0;
          }
          if ($[29] !== can || $[30] !== canOrganization || $[31] !== organizationId) {
            const organizationParams = {
              organizationId
            };
            if (can("ACCESS_TALENTS_MARKETPLACE")) {
              t13 = getPathName(ROUTES.ORGANIZATIONS.RECRUITMENT.INDEX, organizationParams, false);
              break bb0;
            }
            if (canOrganization("GET_ORGANIZATION_USERS")) {
              t13 = getPathName(ROUTES.ORGANIZATIONS.USERS, organizationParams, false);
              break bb0;
            }
            if (canOrganization("ACCESS_ORGANIZATION_ANALYTICS")) {
              t13 = getPathName(ROUTES.ORGANIZATIONS.ANALYTICS, organizationParams, false);
              break bb0;
            }
            $[29] = can;
            $[30] = canOrganization;
            $[31] = organizationId;
          } else {}
          $[25] = can;
          $[26] = canOrganization;
          $[27] = organizationId;
          $[28] = t15;
        } else {}
        $[21] = can;
        $[22] = canOrganization;
        $[23] = organizationId;
        $[24] = t14;
      } else {}
      const teamId = userTeams.entities.find(team => {
        if (!team.id) {
          return false;
        }
        return canTeam("ACCESS_TEAM_ANALYTICS", team.id);
      })?.id;
      if (teamId) {
        t13 = getPathName(ROUTES.TEAMS.ANALYTICS, {
          teamId
        }, false);
        break bb0;
      }
    }
    $[14] = can;
    $[15] = canOrganization;
    $[16] = canTeam;
    $[17] = organizationId;
    $[18] = t12;
    $[19] = user;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  if (t13 !== Symbol.for("react.early_return_sentinel")) {
    return t13;
  }
  return "";
}